import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";
import axios from "axios";

export const createJunkRemoval = createAsyncThunk(
  ActionTypes.CREATE_JUNK_REMOVAL,
  async (sendData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        'junk-removal/create',
        'post',
        sendData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateJunkRemoval = createAsyncThunk(
  ActionTypes.CREATE_JUNK_REMOVAL,
  async (sendData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        'junk-removal/update',
        'patch',
        sendData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getJunkRemoval = createAsyncThunk(
  ActionTypes.GET_JUNK_REMOVAL,
  async (canonicalId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `junk-removal/${canonicalId}`,
        "get",
        canonicalId
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createJunkRemovalItems = createAsyncThunk(
  ActionTypes.CREATE_JUNK_REMOVAL_ITEMS,
  async (sendData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        'junk-removal-items/create',
        'post',
        sendData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);